import axios from 'axios';
import env from './env';

export const checkAuth = () => sendRequest(env.loginVerify);

export const getLayoutData = id => axios.get(`${env.erosURL}${id}.json`);

export const getUserData = () => {
  return sendRequest(`${env.user}/self`)
};

export const getBoxData = (isSharedBox = false, boxId = null) => {
  if (isSharedBox) {
    return sendRequest(`${env.box}/shared/boxes/${boxId}`, "GET", null, {}, true, "no-store");
  } else {
    return sendRequest(`${env.box}/self`, "GET", null, {}, true, "no-store");
  }
}

export const getUserFirstName = (boxId = false) => {
  if (boxId) {
    return sendRequest(`${env.user}/firstname/boxId/${boxId}`, "GET", null, {}, true, "no-store");
  }
  return false
}

 export const getUserAvatar = (boxId = false) => {
  if (boxId) {
    return sendRequest(`${env.hermes}/users/avatar/boxId/${boxId}`, "GET", null, {}, true, "no-store");
  }
  return false;
}

export const getSkipInfo = () => sendRequest(env.accounts);

export const request = (method, url, headers = {}, body = null) => {
  let options = { method, headers: new Headers(headers) };
  if (body)
    options = Object.assign({}, options, { body: JSON.stringify(body) });
  const req = new Request(url, options);
  return req;
};

export const saveRevealState = (boxId, value) => {
  return sendRequest(
    `${env.box}/shipstation/${boxId}/reveal`,
    "PUT",
    JSON.stringify({
      reveal: value
    })
  );
  // return axios({
  //   url: `${env.box}/shipstation/${shipstationId}/reveal`,
  //   method: "PUT",
  //   headers: {
  //     "FFF-Auth": "V1.1",
  //     Origin: env.originURL
  //   },
  //   data: {
  //     reveal: value
  //   }
  // });
};

export const getSpecData = id => sendRequest(`${env.erosURL}` + id + ".json");

const handleUnauthorizedReq = () => {
  window.location = `https://login.${env.originURL}?origin=${
    window.location.href
  }`;
};

const handleInvalidBoxID = () => {
  console.error("Invalid BoxID");
  window.location = "/";
};

// makes an API call and returns a JSON object
const sendRequest = (
  path,
  method = "GET",
  body,
  additionalHeaders = {},
  json = true,
  cache = "default"
) => {
  const defaultHeaders = {
    "FFF-Auth": "V1.1",
    Origin: env.originURL,
    "Content-Type": "application/json; charset=utf-8"
  };
  return fetch(path, {
    credentials: "include",
    headers: { ...defaultHeaders, ...additionalHeaders },
    data: {
      activatedOn: true
    },
    body,
    mode: "cors",
    method,
    cache
  })
    .then(response => json && response.json())
    .then(response => {
      const code = response.code || response.status;
      const message = response.message ? response.message : "";
      if (code === 401) return handleUnauthorizedReq();
      if (code === 404 && message === "Invalid BoxID") return handleInvalidBoxID();
      return response;
    })
    .catch(err => {
      console.error("Fetch Failed: ", err);
      return {"error":err, "success": false};
    });
};

// returns a Request object that we can use to make API requests
export function apiRequest(method = 'GET', path, body) {
  let headers = {
    'FFF-Auth': 'V1.1',
  };

  if (method === 'POST' || method === 'PUT' || method === 'DELETE') {
    headers = {
      ...headers,
      'Content-Type': 'application/json',
      Accept: 'application/json',
    };
  }

  const options = {
    method,
    credentials: 'include',
    headers: new Headers(headers),
  };

  if (method === 'PUT' || method === 'POST' || method === 'DELETE') options.body = JSON.stringify(body);
  return new Request(path, options);
}

export const getUserBoxReview = () => sendRequest(`${env.questionnaire}/ratings/self`, 'GET', null, {}, true, 'no-store');



// WEBPACK FOOTER //
// ./src/utils/data.js